import { message } from "antd";
import { useState } from "react";

type CopiedValue = string | null;
type CopyFn = (text: string) => Promise<boolean>;

export function useCopyToClipboard(): [CopiedValue, CopyFn] {
  const [copiedText, setCopiedText] = useState<CopiedValue>(null);

  const copy: CopyFn = async (text) => {
    if (!navigator?.clipboard) {
      message.warning("Clipboard not supported");
      return false;
    }

    try {
      await navigator.clipboard.writeText(text);
      setCopiedText(text);
      message.info("Copy to Clipboard");
      return true;
    } catch (error) {
      message.error("Copy failed");
      setCopiedText(null);
      return false;
    }
  };

  return [copiedText, copy];
}
